import { configureStore } from '@reduxjs/toolkit';
import { combineReducers } from 'redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import userSlice from './reducers/UserSlice';
import themeSlice from './reducers/ThemeSlice';
import selectFilterScreenSlice from './reducers/SelectFilterScreenSlice';
import limitedAccessSlice from './reducers/restrictScreenSlice';
import permissionRouteSlice from './reducers/PermissionRouteSlice';
const rootReducer = combineReducers({
    user: userSlice,
    theme: themeSlice,
    selectFilterScreen: selectFilterScreenSlice,
    routePermission: permissionRouteSlice,
    limitedAccessScreen: limitedAccessSlice
});
const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['user', 'theme', 'selectFilterScreen','RestrictScreen']
};
const persistedReducer = persistReducer(persistConfig, rootReducer);
const store = configureStore({
    reducer: {
        root: persistedReducer
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['register'],
                ignoredActionPaths: ['rehydrate', 'register'],
                ignoredPaths: ['register']
            }
        })
});

const persistor = persistStore(store);
export { store, persistor };
